<template>
  <div>
    <b-row>
      <b-col cols="6">{{ titleLabelUnitPrice }}</b-col>
      <b-col cols="6">{{ titleLabelTotalPrice }}</b-col>
    </b-row>
    <b-row class="supplierRow mb-3">
      <b-col cols="6">
        <div>
          <span class="smallText">{{ $t('general.netPrice') }}: </span>
          <span class="currency">{{ Number(unitPrice).toLocaleString('de-DE', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2 }) }} {{ currency }}</span>

          <span class="smallText">{{ $t('general.grossPrice') }}: </span>
          <span class="currency">{{ getGrossPrice(unitPrice) }} {{ currency }}</span>
        </div>
      </b-col>
      <b-col cols="6">
        <div>
          <span class="smallText">{{ $t('general.netPrice') }}: </span>
          <span class="currency">{{ Number(totalPrice).toLocaleString('de-DE', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2 }) }} {{ currency }}</span>

          <span class="smallText">{{ $t('general.grossPrice') }}: </span>
          <span class="currency">{{ getGrossPrice(totalPrice) }} {{ currency }}</span>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import { getNetPrice, getGrossPrice } from '@/utils/functions'

export default {
  name: 'SheetRowPurchasePrices',
  props: {
    unitPrice: [String, Number],
    totalPrice: [String, Number],
    currency: String
  },
  computed: {
    titleLabelUnitPrice() {
      return `${this.$t('general.ek_short')} ${this.$t('receiptMatcher.unitPrice')}`
    },
    titleLabelTotalPrice() {
      return `${this.$t('general.ek_short')} ${this.$t('receiptMatcher.totalPrice')}`
    },
  },
  methods: {
    getNetPrice,
    getGrossPrice,
  }
}

</script>